export default __webpack_public_path__ + "resources/icons/d211-2c3b.webp";